import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MediaModule } from '@spartacus/storefront';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { ShimanoImageZoomComponent } from './shimano-image-zoom.component';

@NgModule({
  declarations: [ShimanoImageZoomComponent],
  imports: [CommonModule, MediaModule, NgxImageZoomModule],
  exports: [ShimanoImageZoomComponent],
})
export class ShimanoImageZoomModule {}
